import { http, ep } from '../../client/http';

export const rndRepo = {
  get: async () => {
    const res = await http.get(ep('rnd'));
    return res.data.data;
  }
};
